import React, { useState, useEffect, useRef } from 'react';
import { YMaps, Map, Placemark } from '@pbe/react-yandex-maps';

import './ContactPage.css';

import logoImage from './../../image/logo.svg';
import contactImage from './../../image/image-4.jpg';
import instIcon from './../../image/inst-icon.svg';
import tgIcon from './../../image/tg-icon.svg';
import waIcon from './../../image/wa-icon.svg';
import btnIcon from './../../image/contact-btn-icon.svg';
import btnIconActive from './../../image/active-btn.svg';

const ContactPage = ({ setCurrentPage }) => {
    const [isLocationShow, setisLocationShow] = useState(false);
    const mapRef = useRef(null);

    // автоматический скролл
    useEffect(() => {
        if (isLocationShow && mapRef.current) {
            mapRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [isLocationShow]);

    const handleInfoClick = () => {
        setCurrentPage('InfoPage');
    };

    const handleLocationClick = () => {
        setisLocationShow(!isLocationShow);
    };

    return (
        <div className='contact__wrapper'>
            <div className='contact__container'>
                <div className='contact__logo'>
                    <img src={logoImage} alt='Logo' />
                </div>
                <div className='contact__image'>
                    <img src={contactImage} />
                </div>
                <div className='contact__info'>
                    <p className='contact__address'>
                        Москва, ул. Лобачевского, 37с1, этаж 2
                    </p>
                    <p className='contact__time'>Ежедневно</p>
                    <p className='contact__time_active'>12:00 – 02:00</p>
                </div>
                <div className='contact__links'>
                    <div className='contact__link'>
                        <a
                            href='https://www.instagram.com/hookahplace_wild/'
                            target='_blank'
                            rel='noopener'
                        >
                            <img
                                src={instIcon}
                                className='contact__link_icon'
                            />
                        </a>
                    </div>

                    <div className='contact__link'>
                        <a
                            href='https://t.me/hookahplace_wild'
                            target='_blank'
                            rel='noopener'
                        >
                            <img src={tgIcon} className='contact__link_icon' />
                        </a>
                    </div>

                    <div className='contact__link'>
                        <a
                            href='https://api.whatsapp.com/send/?phone=79371131112&text=Здравствуйте%21+Хочу+забронировать+стол.&type=phone_number&app_absent=0'
                            target='_blank'
                            rel='noopener'
                        >
                            <img src={waIcon} className='contact__link_icon' />
                        </a>
                    </div>
                </div>
                <div className='contact__btns'>
                    <div className='contact__btn' onClick={handleInfoClick}>
                        О нас
                    </div>
                    <a
                        className='contact__btn'
                        href='tel:+79371131112'
                        rel='noopener noreferrer'
                        target='_blank'
                    >
                        Позвонить
                    </a>
                    <div
                        className={
                            isLocationShow
                                ? 'contact__btn_active'
                                : 'contact__btn'
                        }
                        onClick={handleLocationClick}
                    >
                        <p>Как добраться</p>
                        <img
                            src={isLocationShow ? btnIconActive : btnIcon}
                            className='contact__btn_icon'
                        />
                    </div>
                </div>
                {isLocationShow && (
                    <YMaps>
                        <div
                            ref={mapRef}
                            style={{
                                width: '100%',
                                height: '300px',
                                marginBottom: '10px',
                            }}
                        >
                            <Map
                                defaultState={{
                                    center: [55.687715, 37.474507],
                                    zoom: 15,
                                }}
                                width='100%'
                                height='300px'
                            >
                                <Placemark geometry={[55.687715, 37.474507]} />
                            </Map>
                        </div>
                    </YMaps>
                )}
            </div>
        </div>
    );
};

export default ContactPage;
